import {CartComparator} from './cart-comparator';
import {RequestDetails as IRequestDetails} from '../../common/context-data';

export class RequestDetails
  implements IRequestDetails, CartComparator<RequestDetails>
{
  eventCost: number | null;
  customerPaysFee?: boolean;
  eventType: string | null;
  paymentDate: Date | null;
  programEndDate: Date | null;
  programStartDate: Date | null;
  sport: string | null;
  submittedBy: string | null;
  orgName?: string;
  eventName?: string;
  recommended?: boolean;

  constructor(source?: IRequestDetails) {
    if (!source) return;

    Object.assign(this, source);
  }

  equals(a: RequestDetails, b: RequestDetails = this): boolean {
    let result = a === b;
    if (!result && !!a) {
      result =
        a.eventCost === b.eventCost &&
        a.eventType === b.eventType &&
        a.sport === b.sport &&
        a.orgName === b.orgName &&
        a.eventName === b.eventName;
    }
    return result;
  }
}
